export const imageSettingsPropertyToUnitMap = {
    sizeMode: 'enum',
    x: 'number',
    y: 'number',
    quality: 'number',
    highDpi: 'boolean'
};
export const imageSettingsProperties = Object.keys(imageSettingsPropertyToUnitMap);
export var ImageSizeMode;
(function (ImageSizeMode) {
    ImageSizeMode["Fit"] = "fit";
    ImageSizeMode["Stretch"] = "stretch";
    ImageSizeMode["Crop"] = "crop";
})(ImageSizeMode || (ImageSizeMode = {}));
export const DEFAULT_IMAGE_QUALITY = 85;
export const DEFAULT_IMAGE_SETTINGS = {
    x: 0.5,
    y: 0.5,
    quality: DEFAULT_IMAGE_QUALITY,
    sizeMode: ImageSizeMode.Fit,
    highDpi: false
};
